<i18n lang="yaml">
ja:
  fields:
    personal:
      certificates: "保有資格"
</i18n>
<script setup lang="ts">
import { ref } from "vue";
import { storeToRefs } from "pinia";

import { removeItem } from "@/modules/utils";

import { useI18n } from "vue-i18n";
import { use as useSession } from "@/stores/session";

import UITagList from "@/components/ui/TagList.vue";

import ItemTags from "./ProfileTags.vue";

const show = ref(false);

useI18n();
const session = useSession();
const { agent, active } = storeToRefs(session);
const { editing } = defineProps(["editing", "data"]);

const options = {
  certificates: [
    "宅地建物取引士",
    "住宅ローンアドバイザー",
    "サブリース建物取扱主任者",
    "ビル経営管理士",
    "マンション管理士",
    "マンション投資アナリスト",
    "管理業務主任者",
    "競売不動産取扱主任者",
    "空き家課題トータルコンサルタント",
    "住宅建築コーディネーター",
    "住宅販売士",
    "賃貸住宅メンテナンス主任者",
    "賃貸不動産経営管理士",
    "土地家屋調査士",
    "土地活用プランナー",
    "投資不動産取引士",
    "不動産キャリアパーソン",
    "不動産鑑定士",
    "不動産コンサルティングマスター",
    "不動産実務検定 資格保有者",
    "不動産戦略アドバイザー",
    "民泊適正管理主任者",
  ].map((id) => ({ id, label: id })),
};
</script>
<template>
  <div class="field" v-if="agent">
    <h3 class="w6 t16" v-t="'fields.personal.certificates'" />
    <template v-if="editing">
      <div class="tags ro i-box u-row" @click.stop>
        <template v-if="data.personal.certificates">
          <div
            class="tag u-row"
            v-for="tag of data.personal.certificates"
            :key="tag"
          >
            <span>{{ tag }}</span>
            <button
              type="button"
              @click="removeItem(data.personal.certificates, tag)"
            >
              <FontAwesomeIcon class="icon" :icon="['fas', 'circle-xmark']" />
            </button>
          </div>
        </template>
        <input type="text" @focus="show = true" />
      </div>
      <UITagList
        class="options"
        :tags="options.certificates"
        :value="data.personal.certificates"
        @change="data.personal.certificates = $event"
        v-if="show"
        v-click-away="() => (show = false)"
      />
    </template>
    <ItemTags
      :tags="agent.personal.certificates"
      v-else-if="agent.personal.certificates || active"
    />
  </div>
</template>
<style scoped>
.tags.options {
  margin-top: -1px;
}
.tags.ro {
  padding: 4px 12px 12px 12px;
}
input {
  min-width: 80px;
  flex: 1;
  height: 36px;
  margin-top: 8px;
}
</style>
